import api from './api';

export const versionService = {
  getBackendVersion: async () => {
    const response = await api.get('/version');
    return response.data;
  },
};
